<template>
    <BudgetEntries ref="budgetEntries" titleTable="Expenses" category="Expenses"/>
</template>
<script>
    const BudgetEntries = () => import('./list.vue')
    export default {
        name: 'budget-entries-expenses',
        components: {
            BudgetEntries
        },
        methods: {
            updateColumnSettings() {
                this.$refs.budgetEntries.getColumnSettings();
            }
        }
    }
</script>
